(function () {
  "use strict";

  var MOBILE_MQ = "(max-width: 749px)";

  function normalizeLabel(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function getActiveNavigationLabel() {
    var activeItem = document.querySelector(
      "[data-members-week-item].is-active",
    );
    var activeBrandTab = document.querySelector(
      "[data-members-week-brand-tab].is-active",
    );

    if (activeItem) {
      var desktopLabel = activeItem.querySelector(
        ".members-week-navigation__label--desktop",
      );
      var mobileLabel = activeItem.querySelector(
        ".members-week-navigation__label--mobile",
      );
      return (desktopLabel || mobileLabel || activeItem).textContent;
    }

    return activeBrandTab ? activeBrandTab.textContent : "";
  }

  function getSources(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll("[data-hot-summer-source]"),
    );
  }

  function getAllSwiperSources(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll("[data-hot-summer-swiper]"),
    );
  }

  function getDefaultSource(sources) {
    return (
      sources.filter(function (source) {
        return source.getAttribute("data-hot-summer-default-source") === "true";
      })[0] || sources[0]
    );
  }

  function getSourceId(source) {
    return source.getAttribute("data-hot-summer-source-id");
  }

  function getSourceBrand(source) {
    return source.getAttribute("data-hot-summer-source-brand") || "primary";
  }

  function getSourceLabel(source) {
    return normalizeLabel(source.getAttribute("data-hot-summer-source-label"));
  }

  function hasBrandData(section) {
    var brands = getSources(section).map(getSourceBrand);
    var unique = brands.filter(function (brand, index, list) {
      return list.indexOf(brand) === index;
    });
    return (
      unique.length > 1 ||
      unique.indexOf("secondary") !== -1 ||
      unique.indexOf("both") !== -1
    );
  }

  function shouldUseBrandSwitch(section) {
    var sources = getSources(section);
    return hasBrandData(section) || sources.length > 1;
  }

  function filterSourcesByBrand(sources, brand) {
    var validBrands = [brand, "both"];
    return sources.filter(function (source) {
      return validBrands.indexOf(getSourceBrand(source)) !== -1;
    });
  }

  function filterSourcesByTabLabel(sources, tabLabel) {
    if (!tabLabel) return [];
    var normalized = normalizeLabel(tabLabel);
    return sources.filter(function (source) {
      return getSourceLabel(source) === normalized;
    });
  }

  function getActiveBrandTabLabel() {
    var brandTab = document.querySelector(
      "[data-members-week-brand-tab].is-active",
    );
    if (!brandTab) return "";
    return (
      brandTab.getAttribute("data-members-week-button-label") ||
      brandTab.textContent
    );
  }

  function getSectionHost(section) {
    return section.closest(".shopify-section") || section;
  }

  function setSectionBrandVisibility(section, isVisible) {
    var host = getSectionHost(section);
    host.hidden = !isVisible;
    host.classList.toggle(
      "campaign-hotsummeritems-section--brand-hidden",
      !isVisible,
    );
  }

  function hasMembersWeekBrandTabs() {
    return (
      document.querySelectorAll("[data-members-week-brand-tab]").length > 0
    );
  }

  function getVisibleSourcesForBrand(section, brand, tabLabel) {
    var sources = getSources(section);
    if (!sources.length) return [];

    var visible = filterSourcesByBrand(sources, brand);
    if (!visible.length && tabLabel) {
      visible = filterSourcesByTabLabel(sources, tabLabel);
    }

    return visible;
  }

  function applyBrandToSection(section, brand, tabLabel, categoryLabel) {
    if (!hasMembersWeekBrandTabs() || !brand) {
      setSectionBrandVisibility(section, true);
      return false;
    }

    var visible = getVisibleSourcesForBrand(
      section,
      brand,
      tabLabel || getActiveBrandTabLabel(),
    );
    if (!visible.length) {
      setSectionBrandVisibility(section, false);
      return false;
    }

    setSectionBrandVisibility(section, true);

    var activeSource;
    if (categoryLabel) {
      var normalizedCategory = normalizeLabel(categoryLabel);
      var normalizedTab = normalizeLabel(tabLabel || getActiveBrandTabLabel());
      if (normalizedCategory && normalizedCategory !== normalizedTab) {
        activeSource = visible.filter(function (source) {
          return getSourceLabel(source) === normalizedCategory;
        })[0];
      }
    }

    showGroup(section, visible, activeSource || undefined);
    return true;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function destroySwiper(source) {
    var instance = source.__hotSummerSwiper;
    if (instance && typeof instance.destroy === "function") {
      try {
        instance.destroy(true, true);
      } catch (e) {}
    }
    source.__hotSummerSwiper = null;
  }

  function isPaginationEnabled(section) {
    return section.getAttribute("data-show-pagination") !== "false";
  }

  function initSwiper(source) {
    if (typeof window.Swiper !== "function") return;
    if (!source || !source.hasAttribute("data-hot-summer-swiper")) return;
    if (source.__hotSummerSwiper) return;
    var wrapper = source.querySelector(".swiper-wrapper");
    if (!wrapper) return;
    var section = source.closest("[data-campaign-hot-summer-items]");
    var pagination = source.querySelector("[data-hot-summer-pagination]");
    var slideCount = wrapper.querySelectorAll(".swiper-slide").length;
    var usePagination =
      section &&
      isPaginationEnabled(section) &&
      pagination &&
      slideCount > 1 &&
      !source.classList.contains("campaign-hotsummeritems__source--no-pagination");

    source.__hotSummerSwiper = new window.Swiper(source, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      watchOverflow: true,
      threshold: 10,
      simulateTouch: true,
      allowTouchMove: slideCount > 1,
      shortSwipes: true,
      longSwipesRatio: 0.3,
      pagination: usePagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
    });
  }

  function syncSwiperForSource(source) {
    if (!source) return;
    var active = source.classList.contains("is-active");
    if (isMobile() && active) {
      initSwiper(source);
      var instance = source.__hotSummerSwiper;
      if (instance) {
        setTimeout(function () {
          try {
            instance.update();
          } catch (e) {}
        }, 50);
      }
    } else {
      destroySwiper(source);
    }
  }

  function syncSwipersForSection(section) {
    getAllSwiperSources(section).forEach(syncSwiperForSource);
  }

  function updateHeading(section, targetSource) {
    var headingEl = section.querySelector(".campaign-hotsummeritems__heading");
    if (!headingEl) return;

    var sourceHeading = targetSource
      ? targetSource.getAttribute("data-hot-summer-source-heading")
      : "";
    sourceHeading = sourceHeading ? sourceHeading.trim() : "";
    headingEl.textContent =
      sourceHeading ||
      section.__hotSummerDefaultHeading ||
      headingEl.textContent;
  }

  // Show only the given group of sources, activate one of them, hide the rest.
  function showGroup(section, visibleSources, activeSource) {
    var sources = getSources(section);
    if (!sources.length) return;

    if (!visibleSources || !visibleSources.length) visibleSources = sources;
    var visibleIds = visibleSources.map(getSourceId);

    if (!activeSource || visibleIds.indexOf(getSourceId(activeSource)) === -1) {
      activeSource =
        visibleSources.filter(function (source) {
          return source.classList.contains("is-active");
        })[0] || visibleSources[0];
    }

    sources.forEach(function (source) {
      var isActive = source === activeSource;
      source.classList.toggle("is-active", isActive);
      source.hidden = !isActive;
      if (!isActive) destroySwiper(source);
    });

    var activeId = getSourceId(activeSource);
    var tabs = section.querySelectorAll("[data-hot-summer-tab]");
    tabs.forEach(function (tab) {
      var target = tab.getAttribute("data-hot-summer-tab-target");
      tab.hidden = visibleIds.indexOf(target) === -1;
      var isActive = target === activeId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    updateHeading(section, activeSource);

    if (
      isMobile() &&
      activeSource &&
      activeSource.hasAttribute("data-hot-summer-swiper")
    ) {
      initSwiper(activeSource);
      var instance = activeSource.__hotSummerSwiper;
      if (instance) {
        setTimeout(function () {
          try {
            instance.update();
          } catch (e) {}
        }, 50);
      }
    }
  }

  function setGroupByBrand(section, brand, tabLabel) {
    applyBrandToSection(section, brand, tabLabel);
  }

  function setGroupByLabel(section, label) {
    var sources = getSources(section);
    if (!sources.length) return;

    var normalizedLabel = normalizeLabel(label);
    var visible = [];

    if (normalizedLabel) {
      visible = sources.filter(function (source) {
        return getSourceLabel(source) === normalizedLabel;
      });
    }

    if (!visible.length) {
      visible = sources.filter(function (source) {
        return !getSourceLabel(source);
      });
    }

    if (!visible.length) visible = sources;

    showGroup(section, visible);
  }

  function setActiveSourceById(section, id) {
    var sources = getSources(section);
    if (!sources.length) return;

    var target =
      sources.filter(function (source) {
        return getSourceId(source) === id;
      })[0] || getDefaultSource(sources);

    // Keep current visible group (tabs not hidden), just switch the active source.
    var visibleIds = [];
    section.querySelectorAll("[data-hot-summer-tab]").forEach(function (tab) {
      if (!tab.hidden)
        visibleIds.push(tab.getAttribute("data-hot-summer-tab-target"));
    });
    var visible = sources.filter(function (source) {
      return visibleIds.indexOf(getSourceId(source)) !== -1;
    });
    if (visibleIds.indexOf(getSourceId(target)) === -1) visible = sources;

    showGroup(section, visible, target);
  }

  function syncFromNavigation(section) {
    var brandTab = document.querySelector(
      "[data-members-week-brand-tab].is-active",
    );
    var brand = brandTab
      ? brandTab.getAttribute("data-members-week-brand")
      : null;
    var tabLabel = brandTab
      ? brandTab.getAttribute("data-members-week-button-label") ||
        brandTab.textContent
      : "";

    if (hasMembersWeekBrandTabs() && brand) {
      applyBrandToSection(section, brand, tabLabel);
      return;
    }

    setSectionBrandVisibility(section, true);
    setGroupByLabel(section, getActiveNavigationLabel());
  }

  function bindTabs(section) {
    var tabs = section.querySelectorAll("[data-hot-summer-tab]");
    tabs.forEach(function (tab) {
      if (tab.dataset.hotSummerTabBound === "true") return;
      tab.dataset.hotSummerTabBound = "true";
      tab.addEventListener("click", function () {
        if (tab.hidden) return;
        setActiveSourceById(
          section,
          tab.getAttribute("data-hot-summer-tab-target"),
        );
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.campaignHotSummerItemsReady === "true")
      return;
    section.dataset.campaignHotSummerItemsReady = "true";

    var headingEl = section.querySelector(".campaign-hotsummeritems__heading");
    section.__hotSummerDefaultHeading = headingEl
      ? headingEl.textContent.trim()
      : "";

    bindTabs(section);
    syncFromNavigation(section);
    syncSwipersForSection(section);
  }

  function init() {
    document
      .querySelectorAll("[data-campaign-hot-summer-items]")
      .forEach(initSection);
  }

  function handleViewportChange() {
    document
      .querySelectorAll("[data-campaign-hot-summer-items]")
      .forEach(syncSwipersForSection);
  }

  function syncAllFromNavigation() {
    document
      .querySelectorAll("[data-campaign-hot-summer-items]")
      .forEach(syncFromNavigation);
  }

  document.addEventListener("members-week:navigation-change", function (event) {
    var label = event.detail && (event.detail.label || event.detail.brandLabel);
    var brand = event.detail && event.detail.brand;
    document
      .querySelectorAll("[data-campaign-hot-summer-items]")
      .forEach(function (section) {
        if (hasMembersWeekBrandTabs() && brand) {
          applyBrandToSection(section, brand, getActiveBrandTabLabel(), label);
        } else {
          setSectionBrandVisibility(section, true);
          setGroupByLabel(section, label);
        }
      });
  });

  document.addEventListener("members-week-navigation:change", function (event) {
    var brand = event.detail && event.detail.brand;
    var label = event.detail && event.detail.label;
    document
      .querySelectorAll("[data-campaign-hot-summer-items]")
      .forEach(function (section) {
        if (hasMembersWeekBrandTabs() && brand) {
          applyBrandToSection(section, brand, label);
        } else if (label) {
          setSectionBrandVisibility(section, true);
          setGroupByLabel(section, label);
        }
      });
  });

  var mql = window.matchMedia(MOBILE_MQ);
  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", handleViewportChange);
  } else if (typeof mql.addListener === "function") {
    mql.addListener(handleViewportChange);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
